import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';

import { PresentationTemplateStylesService } from '../services/template-styles.service';

export const resolveTemplateVariables: ResolveFn<void> = () => {
  inject(PresentationTemplateStylesService).init();
};
